export default {
	ADMIN_ALLOW_APPROVED_TO_PENDING: 'Admin: Allow setting Approved Timesheet to Pending',
	ADMIN_NURSE_STATUS_HISTORY: 'Admin - Nurse Status History',
	ADMIN_TIMESHEET_DASH_PENDING_REASON_APPROVAL_METHOD_FILTERS:
		'Admin Timesheet Dash Pending Reason & Approval Method Filters',
	ANNOUNCEMENTS: 'Announcements',
	AUTHORIZATION_SCOPES: 'Authorization Scopes',
	AUTO_BACKFILL: 'Auto Backfill',
	BACKFILL_NEEDED: 'Backfill Needed',
	CANCEL_FREE_GUARANTEE: 'Cancel Free Guarantee',
	CICO_MASTER_TOGGLE: 'Check In Check Out',
	CLINICIAN_SKILLS_FLAG: 'Clinician Skills',
	COVID19_DATE_EXTENDED: 'Requirement - COVID-19 Date Extended',
	COVID_CONFIRMED_CASES: 'COVID-19 Confirmed Cases',
	COVID_CONTACT_FLAG: 'COVID-19 Contact Shift Flag',
	CUSTOM_SHIFT_TIMES: 'Custom Shift Times',
	ENABLE_INSTANT_ACCEPT_WHEN_POSTING_SHIFT: 'Enable Instant Accept When Posting Shift',
	HH_MILEAGE: 'HH Mileage',
	HIDE_NURSE_PROFILE_PICTURE: 'Supervisor - Hide Nurse Profile Picture',
	INSTANT_ACCEPT: 'Instant Accept',
	INSTANT_ACCEPT_GLOBAL: 'Instant Accept - Global',
	LIMIT_INSTANT_ACCEPT_TIMES_FEATURE: 'Limit Instant Accept Times',
	LOCATION_REQUIREMENT_REQUIRED_FIELDS: 'Allow Field Level Requirements Per Organization',
	LOCATION_VERIFIED_SHIFTS: 'Location Verified Shifts',
	ONBOARDING_FLOW: 4,
	OPS_BOT_EPIC: 'Ops-bot Epic',
	ORGANIZATION_PRN_POOL: 'Organization PRN Pool',
	ORGANIZATION_SHIFT_LEVEL_BONUS: 'Organization Shift Level Bonus',
	ORGANIZATION_SUPERVISOR_AVAILABILITY_FEATURE: 'Organization - Supervisor Availability',
	RESET_PASSWORD_FLOW: 5,
	SELF_CHECKOUT_EPIC: 'Self Checkout Epic',
	SHIFT_CANCELLATION_BILLABLE_DYNAMIC_HOURS: 'Shift Cancellation Billable Dynamic Hours',
	SHIFT_LEVEL_BONUS: 'Shift Level Bonus',
	SUPERVISOR_ALLOW_MODIFY_POSITIONS_FROM_DASHBOARD: 'Supervisor - Allow Modify Positions From Dashboard',
	SUPERVISOR_ALLOW_MULTIPLE_TIMES_IN_SHIFT_CREATE: 'Supervisor - Allow Multiple Times in Shift Create',
	SUPERVISOR_AVAILABILITY_FEATURE: 'Supervisor Availability',
	SUPERVISOR_BADGE_REMOVAL: 'Supervisor - Nurse Badge Removal',
	SUPERVISOR_CST_TOAST: 'Supervisor CST toast',
	SUPERVISOR_IMPERSONATION: 'Supervisor Impersonation',
	SUPERVISOR_MESSAGE_FEATURE: 'Supervisor Message Feature',
	SUPERVISOR_NEW_CALENDAR: 'Supervisor New Calendar',
	SUPERVISOR_NEW_DASHBOARD: 'Supervisor New Dashboard',
	SUPERVISOR_NURSE_PAGE: 'Supervisor - Nurse Page',
	SUPERVISOR_NURSE_REQUEST_FEATURE: 'Supervisor - Request Nurse',
	SUPERVISOR_QUICK_ACCEPT_OR_DECLINE: 'Supervisor Quick Accept Or Decline',
	SUPERVISOR_SHIFT_LIST_API_V2: 'Supervisor: Shift List API V2',
	SUPERVISOR_SHIFT_POST_AUTOFILL_SINGLE_LOCATION: 'Supervisor Shift Post Autofill Single Location',
	SUPERVISOR_SHIFT_POST_CONFIRMATION: 'Supervisor Shift Post Confirmation',
	SUPERVISOR_TIMESHEETS_MULTIPLE_TABS: 'Supervisor Timesheets - Multiple Tabs',
	USER_REQUIREMENT_FIELD_TYPE_CHECKBOX: 'User Requirement Field Type Checkbox',
	USER_REQUIREMENT_FIELD_TYPE_ROLE: 'User Requirement Field Type Role',
	USER_REQUIREMENT_FIELD_TYPE_STATE: 'User Requirement Field Type State'
};
